var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5094 0L17.0697 1.47315C15.5401 0.598466 13.8155 0 12.0009 0C6.73717 0 2.28321 5.01791 0.618605 7.16625C-0.206202 8.22507 -0.206202 9.7596 0.618605 10.8184C1.35343 11.7698 2.61314 13.243 4.23276 14.6241L3.30297 15.5755L5.41748 17.7391L20.7139 2.08696L18.5094 0ZM3.03304 8.99233C4.20276 7.50384 8.01187 3.06906 12.0009 3.06906C12.9757 3.06906 13.9205 3.34527 14.8353 3.77494L13.9955 4.63427C13.3806 4.34271 12.7208 4.17392 12.0009 4.17392C9.40654 4.17392 7.27704 6.3376 7.27704 9.00768C7.27704 9.72891 7.457 10.4194 7.72694 11.0333L6.36226 12.4297C4.81762 11.1714 3.6029 9.72891 3.03304 8.99233Z",
    fill: "#B33939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3833 7.16632C22.8884 6.52182 22.1236 5.61645 21.1788 4.66504L19.0493 6.84407C19.9041 7.7034 20.5789 8.50136 20.9539 8.99241C19.7991 10.4962 16.005 14.931 12.001 14.931C11.746 14.931 11.4911 14.9157 11.2211 14.8696L8.76172 17.3863C9.78148 17.7699 10.8612 18.0001 11.986 18.0001C17.2497 18.0001 21.7037 12.9822 23.3683 10.8338C24.2081 9.75967 24.2081 8.22514 23.3833 7.16632Z",
    fill: "#B33939"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye-hide.be722986.svg";
export { ForwardRef as ReactComponent };